/* Collapse any Judge.me widget that never gets filled in.
   Judge.me renders client-side, so a widget div is empty until its script runs. If the app
   embed is off, or a product has no reviews yet, the page would otherwise show a heading
   over blank space -- the first cut marked only the inner wrapper, which left the section
   rendering its heading above 255px of nothing. The marker goes on the SECTION so the
   whole block collapses, and comes off again if the widget arrives late. */
(function () {
  var SEL = '.vh-jm, .vhx-jm-badge';

  function live(el) {
    // Judge.me injects its own markup; treat a widget as live once it holds real content,
    // not just whitespace or an empty placeholder div.
    var w = el.querySelector('.jdgm-widget, .jdgm-carousel-wrapper') || el;
    if (w.querySelector('.jdgm-rev, .jdgm-prev-badge__stars, .jdgm-carousel-item, .jdgm-histogram')) return true;
    return w.textContent.trim().length > 0 && w.children.length > 0;
  }

  function mark(el, empty) {
    // the badge sits inline in the buy box and collapses on its own; a widget collapses
    // its whole section so its heading goes with it
    var target = el.classList.contains('vhx-jm-badge') ? el : (el.closest('section') || el);
    if (empty) target.setAttribute('data-jm-empty', '');
    else target.removeAttribute('data-jm-empty');
  }

  function sweep() {
    document.querySelectorAll(SEL).forEach(function (el) { mark(el, !live(el)); });
  }

  function start() {
    sweep();
    var mo = new MutationObserver(sweep);
    document.querySelectorAll(SEL).forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true });
    });
    // Judge.me can load late on a slow connection; stop watching once it has settled.
    setTimeout(sweep, 1200);
    setTimeout(sweep, 4000);
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
